import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from 'interfaces';

import AlbumsComponent from 'components/Albums';

import { loadAlbums } from './albumsSlice';

const Albums = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(loadAlbums());
  }, [dispatch]);

  const albums = useSelector((state: RootState) => state.albums.albums);

  return (
    <AlbumsComponent albums={albums} />
  );
};

export default Albums;
